var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"declined-title"},[_vm._v(" We are unable to offer you a loan at this time. ")]),_c('p',[_vm._v(" Unfortunately, you do not currently meet our eligibility requirements. Thank you for taking the time to apply, and feel free to return in a few months to make another request. ")])])
}]

export { render, staticRenderFns }